import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { TableOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';
import { ROUTE_NAMES } from '../names';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.sort 排序越小越排前
 *
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/scene',
    name: ROUTE_NAMES.SCENE,
    // redirect: '/list/basic-list',
    redirect: '/scene/list',
    component: Layout,
    meta: {
      title: '情景分类管理',
      icon: renderIcon(TableOutlined),
      sort: 3,
    },
    children: [
      {
        path: 'scenes',
        name: ROUTE_NAMES.SCENES,
        meta: {
          title: '情景分类列表',
        },
        component: () => import('@/views/scene/index.vue'),
      },
    ],
  },
];

export default routes;
